module.exports = __webpack_public_path__ + "img/four_bg.f85de321.jpg";